<template>
  <div id="login-step1" class="">
    <div id="main-part">
      <h2>ACCESO</h2>
      <p class="primary-text has-text-centered">{{ texts.login.intro_text }}</p>
      <div class="login-forms-container onlyline-field">
        <b-field :type="type_email" :message="msg_email">
          <b-icon class="onlyline-icon" pack="mdi" icon="email-outline" size="is-small">
          </b-icon>
          <b-input ref="emailField" type="email" class="onlyline" placeholder="email" v-model="inputs.email" required
            expanded>
          </b-input>
        </b-field>

        <b-field :type="type_password" :message="msg_password" class="onlyline-field">
          <b-icon class="onlyline-icon" pack="mdi" icon="lock" size="is-small">
          </b-icon>
          <b-input @keydown.native.enter="handleEnterKey" ref="passwordField" type="password" class="onlyline"
            placeholder="password" v-model="inputs.password" required expanded password-reveal>
          </b-input>
        </b-field>
      </div>
      <div class="mt-5">
        <router-link to="resetpassword" class="is-size-7">
          <div class="link-reset">
            <a href="" class="a-reset">
              <img src="@/assets/imgs/info.svg" class="mr-1" />
              He olvidado mi contraseña
            </a>
          </div>
        </router-link>
      </div>
      <div class="login-button-container">
        <a @click="login(inputs)" class="button is-medium is-fullwidth is-primary" :class="classLoading">
          <span> Acceder </span>
          <span class="icon is-small">
            <i class="mdi mdi-arrow-right"></i>
          </span>
        </a>
      </div>

      <div class="login-button-container register">
        <p class="primary-text has-text-centered">Si todavía no te has registrado</p>

        <router-link to="register">
          <a class="button btn-register is-medium is-fullwidth">
            <span class="text-register"> Regístrate aquí </span>
            <span class="icon is-small">
              <i class="mdi mdi-arrow-right"></i>
            </span>
          </a>
        </router-link>
      </div>
    </div>

    <div id="belowbutton">
      <p class="interface-small-text has-text-grey-light has-text-centered">
        {{ texts.login.text2 }}
      </p>
    </div>
  </div>
</template>
<script>
import { RegisterStepMixin } from '@/components/mixins/RegisterStepMixin'
import { ToolsMixin } from '@/components/mixins/ToolsMixin'
export default {
  name: 'UserLogin',

  data: () => ({
    inputs: {
      email: '',
      password: ''
    },
    msg_email: '',
    type_email: '',
    msg_password: '',
    type_password: '',
    isLoading: false
  }),
  mixins: [RegisterStepMixin, ToolsMixin],
  props: {
    webname: {
      type: String,
      default: 'navandu.me'
    }
  },
  methods: {
    login({ email, password }) {
      this.isLoading = true
      if (this.ifFormValid() == false) {
        this.isLoading = false
        return
      }
      this.$store
        .dispatch('auth/login', { email, password })
        .then((r) => {
          if (
            this._.get(
              r.data,
              'data.user.statuses.doctor.name',
              'STATUS_FAIL_INCOMPLETE'
            ) === 'STATUS_OK'
          ) {
            //this.$router.push("chat")
            window.location.href =
              this.$store.getters['decoupled/getProperConfig'].nexturl
            console.log(r)
          } else {
            window.location.href =
              this.$store.getters['decoupled/getProperConfig'].nexturl
            console.log(r)
          }
          //this.isLoading=false;
        })
        .catch((error) => {
          console.log(error.response)
          this.isLoading = false
          this.type_email = 'is-danger'
          this.msg_email = error.response.data.title
        })

      //this.$parent.close()
    },
    ifFormValid() {
      var isValid =
        this.$refs.emailField.checkHtml5Validity() &&
        this.$refs.passwordField.checkHtml5Validity()
      return isValid
    },
    handleEnterKey() {
      this.login(this.inputs)
      this.$refs.passwordField.$el.firstElementChild.blur()
    }
  },
  computed: {
    classLoading: function () {
      if (this.isLoading == true) return 'is-loading'
      else return ''
    }
    //texts: function(){ return this.$store.state.decoupled.configFile.texts}
  },
  created() { }
}
</script>
<style lang="less">
//@import (reference) '../assets/styles/main.less';
/* only if it is embeded within the home */

.link-reset {
  text-align: -webkit-right;

  .a-reset {
    color: #ababab;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex !important;
    justify-content: center;
    align-items: center;
    margin: 8px 0 0 3px;
    width: max-content;
  }
}

.login-forms-container {
  width: 100%;
  margin-top: 24px;
}

.login-button-container.register {
  border-bottom: none;
}

.btn-register {
  border-radius: 3px;
  border: 1px solid #0ac6d3;
  background: #fff;
  margin-top: 22px;
  margin-bottom: 150px;
}

.btn-register:hover {
  border: 1px solid #1ce6f4;
}

.text-register {
  color: #0ac6d3;
}

.login-button-container {
  text-align: center;
  padding: 40px 0;
  border-bottom: 1px solid #e0e0e0;
}

.login-button {
  width: 100%;
  height: 52px;
  font-size: 22px;
  font-weight: 300;
  justify-content: space-between;
}

.onlyline input {
  padding: 0px;
  width: calc(100% - 10px);
}

#login-step1 {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}
</style>
